import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Checkbox } from "antd";
import { useZsplDepotVehicles } from "misc/api/datalayer";
import { Card } from "misc/card";
import { NumberField, TextField } from "misc/fields";
import { Table } from "misc/tables";
import { clientUrls } from "misc/urls";
import SideHeader from "navigation/SideHeader";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useParams } from "react-router-dom";

const STATUS_LABEL_KEYS = {
    available: "t_available",
    not_available: "t_not_available",
    unknown: "t_to_be_checked",
    available_low_battery: "t_low_battery"
};

const DrillDownDashboard = () => {
    const location = useLocation();
    const date = location.state?.date;
    const { t } = useTranslation();
    const { depotId } = useParams();
    const { depotVehicles, isLoading, isRefetching } = useZsplDepotVehicles(depotId, date);
    const [hideAvailable, setHideAvailable] = useState(false);

    const filteredVehicles = useMemo(() => {
        if (hideAvailable) {
            return depotVehicles.filter(vehicle => vehicle.status !== "available");
        }
        return depotVehicles;
    }, [hideAvailable, depotVehicles]);

    const vehicleColumns = [
        {
            title: t("t_vehicles"),
            dataIndex: "vin",
            key: "vin",
            render: text => <TextField value={text} enableCopy />,
            width: 250
        },
        {
            title: t("t_status"),
            dataIndex: "status",
            key: "status",
            render: status => <TextField value={STATUS_LABEL_KEYS[status] ? t(STATUS_LABEL_KEYS[status]) : status} />,
            width: 190
        },
        {
            title: t("t_defect_tickets_id"),
            dataIndex: "defect_tickets",
            key: "defect_tickets",
            render: val => {
                return <TextField />;
            },
            width: 220
        },
        {
            title: t("t_soc_before_departure"),
            dataIndex: "soc_percentage",
            key: "soc_percentage",
            render: value => <NumberField value={value} suffix="%" />
        },
        {
            title: "HU",
            dataIndex: "hu_due",
            key: "hu_due",
            render: value => {
                return <TextField />;
            },
            width: 120
        }
    ];

    const depotName = location.state?.depotName ?? t("t_organisational_unit_depot");

    return (
        <SideHeader>
            <Card
                title={depotName}
                stretchHeight
                extra={
                    <Link to={clientUrls.zspl.baseUrl()}>
                        <span style={{ fontSize: "14px", cursor: "pointer" }}>
                            <FontAwesomeIcon icon={["fas", "arrow-left"]} style={{ marginRight: "8px" }} />
                            {t("t_back_to_overview")}
                        </span>
                    </Link>
                }
            >
                <div style={{ marginBottom: "16px" }}>
                    <Checkbox checked={hideAvailable} onChange={e => setHideAvailable(e.target.checked)}>
                        {t("t_hide_available")}
                    </Checkbox>
                </div>

                <Table
                    dataSource={filteredVehicles}
                    columns={vehicleColumns}
                    rowKey="vehicle_id"
                    isLoading={isLoading}
                    isUpdating={isRefetching}
                    size="small"
                    scroll={{ x: "100%" }}
                    sticky
                />
            </Card>
        </SideHeader>
    );
};

export default DrillDownDashboard;
